export class PriceRange {
    constructor(
        public Min: number,
        public Max: number
    ) {
    }
} 